module.exports = __webpack_public_path__ + "img/planet-icon.4c353a46.svg";